import React from "react";
import "../styles/landingpage.css";
import { getBannerImage } from "../utils/CommonFunction";

type Props = {
  otp: {
    one: string;
    two: string;
    three: string;
    four: string;
  };
  handleChangeOTP: (e: any, index: any) => void;
  handleBackspace: (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => void;
  onResendOtpPressed: () => void;
  inputRef: React.RefObject<HTMLInputElement>[];
  showLoader: boolean;
  errorMsg: string;
  showError: boolean;
  onVerifyPressed: () => void;
  phoneNo: string;
  handlePhoneNoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  seconds: number;
  isHidden: boolean;
  isChecked: boolean;
  parameter: string;
  handleOverLay: () => void;
  onPressCheckBox: () => void;
  utm_campaign: string

};


export const EasyPaisaLandig = (props: Props) => {
 const selectedImg = getBannerImage(
    props.utm_campaign,
    props.parameter
  );
  return (
    <div className="">
      <div className="dm-section">
        <div className="main-content">
          <img
            src={selectedImg}
            alt="sports"
            width={345}
            height={333}
            className="lp-main-image"
          />

          <div className="lp-absolute-content">
            <div className="numberdiv">
              <p className="landingtext">Please enter your easypaisa number</p>

              <div className="input-wraper easypasa_input">
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/easypasa_logo.webp"
                  width={70}
                  height={30}
                  alt="easypasa"
                />
                <input
                  type="number"
                  placeholder="3XX - XXXXXXX"
                  className="numberinput"
                  max={10}
                  value={props.phoneNo}
                  onChange={(e) => {
                    props.handlePhoneNoChange(e);
                  }}
                />
              </div>
            </div>
            {/* otp div */}
            {props.showError && <p className="error">{props.errorMsg}</p>}

            <div className="otpDiv">
              {props.phoneNo.length === 10 ? (
                <>
                  <p className="landingtext">
                    Please enter the OTP received via SMS.
                  </p>
                  <div className="otpinputWraper">
                    <input
                      type="tel"
                      name="one"
                      maxLength={1}
                      autoFocus
                      value={props.otp.one}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 0);
                      }}
                      ref={props.inputRef[0]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 0);
                      }}
                    />
                    <input
                      type="tel"
                      name="two"
                      maxLength={1}
                      value={props.otp.two}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 1);
                      }}
                      ref={props.inputRef[1]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 1);
                      }}
                    />
                    <input
                      type="tel"
                      name="three"
                      maxLength={1}
                      value={props.otp.three}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 2);
                      }}
                      ref={props.inputRef[2]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 2);
                      }}
                    />
                    <input
                      type="tel"
                      name="four"
                      maxLength={1}
                      value={props.otp.four}
                      onChange={(e) => {
                        props.handleChangeOTP(e, 3);
                      }}
                      ref={props.inputRef[3]}
                      onKeyDown={(e) => {
                        props.handleBackspace(e, 3);
                      }}
                    />
                  </div>

                  {/* <div className="invalidotp">Invalid OTP entered</div> */}

                  <div className="otpcounter">
                    <p>
                      {props.seconds === 0 ? (
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={props.onResendOtpPressed}
                        >
                          Resend Otp
                        </a>
                      ) : null}
                      {props.seconds > 0 && (
                        <>
                          <>Resend 00:{props.seconds}</>
                          {props.seconds === 0 && (
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={props.onResendOtpPressed}
                            >
                              Resend Otp
                            </a>
                          )}
                        </>
                      )}
                    </p>
                  </div>
                  {props.showLoader ? (
                    <div className="subscribe-btn">
                      <button>Loading...</button>
                    </div>
                  ) : (
                    <div className="subscribe-btn">
                      <button onClick={props.onVerifyPressed}>
                        Subscribe Now
                      </button>
                    </div>
                  )}
                </>
              ) : null}
            </div>

            <div className="policytext">
              <div className="checkflex">
                <input
                  type="checkbox"
                  checked={props.isChecked}
                  onChange={props.onPressCheckBox}
                />
                <p>
                  By signing in, you agree to the{" "}
                  <a href="https://tamashaweb.com/terms-of-use" target="_blank">
                    {" "}
                    Terms of Use
                  </a>{" "}
                  and
                  <a href="/privacy-policy" target="_blank">
                    {" "}
                    Privacy Policy.
                  </a>
                </p>
              </div>

              {/* {props.package_id === "1" ? ( */}
              <p style={{ fontStyle: "Italic", marginTop: "10px" }}>
                * Continue click krne se aap ke account se Rs. 1 kat jayega. Yeh
                offer 24 hours ke liye valid hai jis ke baad automatically Rs.
                360/month inc. tax deduct honge.
              </p>
              {/* ) : (
                <> */}
              {/* {props.package_id === "2" ? (
                    <p>Rs. 120/week for Prepaid & Rs. 360/mon for Postpaid</p>
                  ) : (
                    <>
                      {props.package_id === "3" ? (
                        <p>Rs. 360/month for Prepaid & Postpaid</p>
                      ) : (
                        <p>Rs. 10 day for Prepaid & Rs. 360/mon for Postpaid</p>
                      )}
                    </>
                  )}
                </>
              )} */}
            </div>
          </div>
          <div
            className={`cong-overlay ${props.isHidden ? "hidden" : ""}`}
            onClick={props.handleOverLay}
          ></div>
          <div className={`cong-box ${props.isHidden ? "hidden" : ""}`}>
            <img
              src="https://cdn.econceptionscdn.com/Tamasha/imgs/yellowstar.webp"
              alt="star"
            />
            <div className="mubarakhead">Mubarak Ho!</div>
            <div className="mubaraltext">
              Aap Kamyabi k sath Tamasha Family Ka hisa ban chukay hain,
              <br /> Abhi Tamasha app download karein!
            </div>
            <div className="tamashastore">
              <a href="https://app.tamashaweb.com/JHLA" target="_blank">
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/appstore.webp"
                  alt="app store"
                />
              </a>
              <a href="https://app.tamashaweb.com/JHLA" target="_blank">
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/google_play.webp"
                  alt="google play"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EasyPaisaLandig;
